import React, { useEffect, useState } from "react";
import "./css/landingpage.css";
import Header from "../components/LandingComponents/Header";
import Academies from "../components/LandingComponents/Academies";
import MaintenanceRequest from "../components/LandingComponents/MaintancesRequest";
import FeedbackForm from "../components/LandingComponents/FeedbackForm";
import LandingFooter from "../components/LandingComponents/LandingFooter";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useGetAcademyQuery } from "./../slices/userApiSlice";
import slider01 from "./../assets/images/newbanner1.jpg";
import slider02 from "./../assets/images/newbanner2.jpg";
import slider03 from "./../assets/images/newbanner3.jpg";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { FaArrowAltCircleRight } from "react-icons/fa";

const Landingpage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: academies, isLoading, error, refetch } = useGetAcademyQuery();
  const [academyList, setAcademyList] = useState([]);

  const handleGetStarted = () => {
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    if (academies && Array.isArray(academies)) {
      setAcademyList(academies);
    }
  }, [academies]);

  const images = [slider01, slider02, slider03];
  const totalSlides = images.length;

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const autoplayInterval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(autoplayInterval);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((currentSlide + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");

    const revealOnScroll = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      },
    );

    revealElements.forEach((element) => {
      revealOnScroll.observe(element);
    });

    return () => {
      revealElements.forEach((element) => {
        revealOnScroll.unobserve(element);
      });
    };
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const selector = location.state.scrollTo;
      // Use a timeout to ensure the DOM is ready
      const timeoutId = setTimeout(() => {
        if (selector === "top") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          document
            .querySelector(selector)
            ?.scrollIntoView({ behavior: "smooth" });
        }
        // Clear the state after scrolling so it doesn't scroll again on refresh
        navigate(location.pathname, { replace: true, state: {} });
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [location.state, navigate, location.pathname]);

  return (
    <div>
      <Header />

      {/* Hero Section */}
      <section className="hero-section">
        {/* Background Slider */}
        <div className="hero-slider">
          {images.map((img, index) => (
            <img
              key={index}
              className={`hero-slide-image ${
                index === currentSlide ? "active" : ""
              }`}
              src={img}
              alt={`Academy ${index + 1}`}
            />
          ))}
          <div className="hero-overlay"></div>
        </div>

        {/* Hero Content */}
        <div className="hero-content-wrapper">
          <div className="hero-content">
            <div className="hero-pretitle">
              National Housing Development Corporation Limited
            </div>
            <h1 className="hero-title">
              Facility <span className="hero-text-gradient">Management</span>
              <br />
              <span className="hero-highlight">System</span>
            </h1>
            <p className="hero-subtitle">
              Advancing operational excellence for Gyalsung Academies through
              integrated maintenance coordination, strategic asset management,
              and optimized facility performance.
            </p>
            <div className="hero-actions">
              <button
                onClick={() =>
                  document
                    .querySelector(".mr-container")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="hero-cta-btn"
              >
                <span>Report Issue</span>
                <svg
                  className="cta-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <Link to="/login" className="hero-secondary-btn">
                Access Portal
              </Link>
            </div>
          </div>
        </div>

        {/* Slider Indicators */}
        <div className="hero-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`indicator-dot ${
                index === currentSlide ? "active" : ""
              }`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Scroll Indicator */}
        <div className="hero-scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="scroll-arrows">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      <div className="llowercontainer">
        <div className="reveal reveal-delay-200">
          <Academies
            academies={academies}
            isLoading={isLoading}
            error={error}
          />
        </div>
        <div className="reveal reveal-delay-400">
          <MaintenanceRequest />
        </div>

        <div className="reveal reveal-delay-600">
          <FeedbackForm />
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};
export default Landingpage;
